import { render, staticRenderFns } from "./radioBox.vue?vue&type=template&id=5e9d13dc&scoped=true"
import script from "./radioBox.vue?vue&type=script&lang=js"
export * from "./radioBox.vue?vue&type=script&lang=js"
import style0 from "./radioBox.vue?vue&type=style&index=0&id=5e9d13dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d13dc",
  null
  
)

export default component.exports